

import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {RequirementsClient, StateFeeRequirementViewModel, Provider} from "@/api-client";
import {cultureService} from "@/CultureService";

@Component({})
export default class SwedbankBankLinkPaymentInfo extends Vue {
  @Prop({required: true})
  requirement!: StateFeeRequirementViewModel;
  @Prop({required: true})
  applicationId!: string;

  providers: Provider[] = [];

  chosenBic = "";
  culture = "";

  async created() {
    this.culture = cultureService.currentCulture2Letter;
    console.log(this.culture);
    this.providers = await new RequirementsClient().swedbankBankLinkProviders(this.applicationId, this.requirement.id);
  }

  bankLinkOptionChosen(bic: string) {
    this.$emit('swedbank-bank-link-option-chosen', bic)
  }
}
